const iconBase = GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/gmaps';
const isSunParks = GLOBAL_SCRIPTS.UNIVERS.toUpperCase() === 'SP';

export default Backbone.Model.extend({
  defaults: {
    isLoaded: false,
    markers: [],
    userLocationMarker: false,
    defaultProductCode: '',
    options: {
      places: false,
      infoWindow: true,
      markersCluster: true
    },

    iconsMarker: {
      regular: isSunParks ? `${iconBase}/ico_marker--SP.svg` : `${iconBase}/ico_marker.svg`,
      over: isSunParks ? `${iconBase}/ico_marker_hover--SP.svg` : `${iconBase}/ico_marker_hover.svg`,
      active: isSunParks ? `${iconBase}/ico_marker_hover--SP.svg` : `${iconBase}/ico_marker_hover.svg`
    },

    // configuration par défaut
    config: {
      zoom: 8,
      scrollwheel: true,
      zoomControl: true,
      disableDefaultUI: true
    },

    map: {},
    styles: [
      {
        featureType: 'landscape.man_made',
        elementType: 'geometry.fill',
        stylers: [{
          color: '#ebf5eb'
        }]
      },
      {
        featureType: 'landscape.natural.terrain',
        elementType: 'geometry.fill',
        stylers: [{
          visibility: 'off'
        }]
      },
      {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [{
          visibility: 'off'
        }]
      },
      {
        featureType: 'road',
        elementType: 'all',
        stylers: [{
          visibility: 'off'
        }]
      },
      {
        featureType: 'water',
        elementType: 'geometry.fill',
        stylers: [{
          color: '#dff6fa'
        }]
      }
    ]
  }
});